<template>
	<div>
		<headdv :headTitle="headTitle" :isBackShow="true" :goPath="goPatHead" :activeWebTitle = 'activeWebTitle'></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<!-- start -->
				<!-- <div class="header flex-row">
					<div></div>
					<div class="title">后台账号管理</div>
					<div class="add" @click="addManager">添加</div>
				</div> -->
				<headdv2 @tapAddFun="addManager" @SearchFun="SearchFun"    :headData="headData" ></headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%">
						<el-table-column prop="id" label="ID"></el-table-column>
						<el-table-column prop="username" label="用户名"></el-table-column>
						<el-table-column prop="ar_id" label="部门" :formatter="formatter_ar_id"></el-table-column>
						<el-table-column prop="au_nickname" label="使用人"></el-table-column>
						<el-table-column prop="created_at" label="添加时间" min-width="190"></el-table-column>
						<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="editTangChuan(scope.row)"	>编辑</el-button>
							<el-button size="small"	type="text"	icon="iconfont icon-qingchujiaose"	@click.native.prevent="handleDeleteClick(scope.row)"	>删除</el-button>
						</template>
						</el-table-column>
					</el-table>
				</div>
				<!--分页-->
            	<page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="450px" class="dialog" :close-on-click-modal='false'>
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="95px">
				<el-form-item label="用户名：" prop="username">
					<el-input v-model="staffForm.username" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="密码：" prop="password">
					<el-input type="password" v-model="staffForm.password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item label="角色分配：" prop="id">
					<el-select v-model="staffForm.ar_id" placeholder="请选择角色" >
						<el-option
							v-for="item in problemArrId_type"
							:key="item.id"
							:label="item.ar_name"
							:value="item.id"
						>
							<span style="float: left">{{ item.ar_name }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="使用人：" prop="au_nickname">
					<el-input v-model="staffForm.au_nickname" placeholder="请输入使用人"></el-input>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog" :close-on-click-modal='false'>
			<div class="dialog-title" slot="title">删除</div>
			<!-- 内容区 start-->
			<span>确定删除?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			headData:{
				search_placeholder:'请输入用户名称',
				add:true,
				search:true,
				del:false,
				condition1:false,
				condition2:false,
				condition3:false,
				condition4:false,
				condition5:false,
				condition6:false,
				condition8:false,
				condition9:false,
				condition11:false,
			},
			searchVal:'',   //搜索
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			activeWebTitle:'设置',
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			//分组id
			problemArrId_type: [],
			accountList: [], //列表数据
			checkedList: [], //选中的绑定值
			headTitle: "员工管理",
			goPatHead: "settings",
			dialogVisible: false,   //开启验证
			isEditOrAdd: false, //判断是添加还是编辑，true为编辑/false为添加
            //修改编辑的数据
			staffForm: {
				id: "",
				username: "",
				password: "",
				ar_id: "",
				au_nickname: "",
			},
			//验证规则
			rules: {
				username: [
				{ required: true, message: "请输入管理员账号", trigger: "blur" },],
				password: [{ required: true, message: "请输入密码", trigger: "blur" }],
				ar_id: [{ required: true, message: "请选择角色", trigger: "blur" }],
				au_nickname: [{ required: true, message: "请输入使用人", trigger: "blur" }],
			},
		};
	},
	created() {
		this.getclasslist_arrid();
		this.getclasslist();
	},
	methods: {
		//格式化内容--部门		
		formatter_ar_id(row, column, cellValue, index) {
			for (let i = 0; i < this.problemArrId_type.length; i++) {
				if (cellValue == this.problemArrId_type[i].id) {
				return this.problemArrId_type[i].ar_name;
				}
			}
		},
		//返回
		goBack() {
			this.$router.go(-1);
		},
		//获取列表数据--部门列表
		getclasslist_arrid() {
			var timestamp = Date.parse(new Date());
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&v=${timestamp}`;
			this.https(this.apiList.getRoleList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
				this.problemArrId_type = response.data.data.data; //列表数据
				}
			});
		},
		//获取列表数据--职员列表
		getclasslist() {
			var timestamp = Date.parse(new Date());
			this.is_ok = false; //控制帅选请求 一个一个来

			let get = `?pagesize=${this.pageData.pagesize}&pageindex=${this.pageData.pageindex}&key=${this.searchVal}&v=${timestamp}`;

			this.https(this.apiList.getAdminUserList + `${get}`).then((response) => {

				if (response.data.code == this.common.code) {

               		this.accountList = response.data.data.data; //列表数据

					this.pageData.pagecount = response.data.data.total_page; //总页数

					this.pageData.count = response.data.data.total; //总条数
				}

			});

		},
		// 点击添加按钮
		addManager() {
			for(let key in this.staffForm){
				this.staffForm[key] = ''
			}
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key != 'id'){
					fromData[key] = this.staffForm[key]
				}
			}
			this.https(this.apiList.addAdminUser, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					for(let key in this.staffForm){
						this.staffForm[key] = ''
					}
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				}
			);
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			for(let key in this.staffForm){
				this.staffForm[key] = row[key]
			}
			this.dialogVisible = true;
			this.isEditOrAdd = true;
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			let fromData = {}
			for(let key in this.staffForm){
				fromData[key] = this.staffForm[key]
			}
			this.https(this.apiList.updateAdminUser,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					//弹窗提示
					this.tc_element(	response.data.msg,	response.data.code,	2,	"编辑职员账号");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {
				ids : this.delarr[0],
			}
			this.https(this.apiList.deleteAdminUser, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
		// 保存
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//搜索方法
        SearchFun(data){
			console.log(data)
			this.searchVal = data
			this.getclasslist()
        },
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		//分页
		//pageSize 改变时会触发    每页条数
		handleSizeChange(val) {
			console.log(val)
			this.pageData.pagesize = val 
			this.getclasslist();
		},
		//currentPage 改变时会触发     当前页
		handleCurrentChange(val) {
			console.log(val)
			this.pageData.pageindex = val
			this.getclasslist();
		},
	},
};
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #f2f2f2;
  justify-content: space-between;

  ::v-deep .el-page-header__left {
    color: #aaaaaa;
  }
  ::v-deep .el-page-header__left::after {
    background-color: transparent;
  }
  .title {
    font-size: 18px;
    color: #4f7da4;
  }
  .add {
    width: 60px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 6px;
    color: #ffffff;
    background: #4f7da4;
    cursor: pointer;
  }
}
// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>